import { render, staticRenderFns } from "./IframeDocumentDownload.vue?vue&type=template&id=5dec81fa"
import script from "./IframeDocumentDownload.vue?vue&type=script&lang=js"
export * from "./IframeDocumentDownload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports